<template>
  <v-app>
    <template v-if="$auth0.isAuthenticated">
      <p-navigation-drawer
        v-model="drawer"
        :items="navigation"
      />
      <p-app-bar
        @click="drawer = true"
      />
      <v-main>
        <v-slide-x-transition mode="out-in">
          <router-view :key="$route.name" />
        </v-slide-x-transition>
      </v-main>
      <v-snackbar
        :timeout="-1"
        :color="$toast.type"
        :value="$toast.show"
        multi-line
      >
        {{ $toast.message }}
        <template #action="{ attrs }">
          <v-btn
            text
            v-bind="attrs"
            @click="$toast.clear"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <p-footer />
    </template>
    <div
      v-else
      class="center-vert-horiz"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        :size="50"
      />
    </div>
  </v-app>
</template>

<script>
  import PAppBar from '@my-prtg-com/shared/src/components/presentational/PAppBar'
  import PNavigationDrawer from '@my-prtg-com/shared/src/components/presentational/PNavigationDrawer'
  import PFooter from '@my-prtg-com/shared/src/components/presentational/PFooter'

  export default {
    components: {
      PNavigationDrawer,
      PAppBar,
      PFooter,
    },
    data () {
      return {
        drawer: false,
        navigation: [
          {
            title: 'Overview',
            icon: '$mdiViewDashboard',
            to: '/',
            show: () => true,
          },
          {
            title: 'Account',
            icon: '$mdiAccountBox',
            to: '/account',
            show: () => this.$vuetify.breakpoint.smAndDown,
          },
          {
            title: 'Invoices',
            icon: '$mdiReceipt',
            to: '/invoice',
            show: () => true,
          },
          {
            title: 'Upload',
            icon: '$mdiFileUpload',
            to: '/upload',
            show: () => true,
          },
          {
            title: 'Microsoft Entra ID',
            icon: '$mdiMicrosoftWindows',
            to: '/microsoft-entra-id',
            show: () => true,
            new: true,
          },
          {
            title: 'Support',
            icon: '$mdiLadybug',
            to: '/support',
            show: ({ roles }) => roles?.includes('supporter'),
          },
          {
            title: 'Rollouts',
            icon: '$mdiPackage',
            to: '/rollouts',
            show: ({ roles }) => roles?.includes('supporter'),
          },
          {
            title: 'Account',
            icon: '$mdiAccountBox',
            to: '/account',
            show: () => true,
          },
        ],
      }
    },
  }
</script>

<style lang="scss">
  #app {
    color: var(--v-secondary-base);
    background-color: var(--v-background-base);
  }

  .center-vert-horiz {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
  }

  .container {
    &--max-width {
      max-width: 1200px !important; /* overwrite the the rules of vuetify */
    }

    &--fill-height {
      height: 100%;
    }
  }
</style>
